  import React from 'react';
  import ReactDOM from 'react-dom/client';
  import { BrowserRouter } from 'react-router-dom';
  import { AuthProvider } from './context/AuthContext.js';
  import { AudioProvider } from './context/AudioContext.js';
  import { SpeechProvider } from './context/SpeechContext.js';
  import { GoogleOAuthProvider } from '@react-oauth/google';
  import App from './App.js';
  import reportWebVitals from './reportWebVitals.js';
  import './styles/index.css';
  import { I18nProvider } from './i18n';

  if (window.location.hostname === 'qproject-frontend.onrender.com') {
    window.location.replace('https://quiddit-nine.vercel.app' + window.location.pathname + window.location.hash);
  }

  // Inicializar tema:
  // - Si el usuario ya tiene preferencia en localStorage -> usarla.
  // - Si no, aplicar 'dark' por defecto (como pediste).
  try {
    const stored = localStorage.getItem('darkMode');
    if (stored === 'true') {
      document.documentElement.setAttribute('data-theme', 'dark');
    } else if (stored === 'false') {
      document.documentElement.setAttribute('data-theme', 'light');
    } else {
      // preferencia no definida: aplicamos dark por defecto
      document.documentElement.setAttribute('data-theme', 'dark');
      localStorage.setItem('darkMode', 'true'); // opcional: guardar la preferencia inicial
    }
  } catch (e) {
    // en entornos restrictivos fallback a dark
    try { document.documentElement.setAttribute('data-theme', 'dark'); } catch (_) {}
  }

  // Replace with your actual Google Client ID from environment variable
  const GOOGLE_CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID || "YOUR_GOOGLE_CLIENT_ID_PLACEHOLDER";

  const root = ReactDOM.createRoot(document.getElementById('root'));
  root.render(
    <React.StrictMode>
      <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>
        <BrowserRouter>
          <I18nProvider>
            <AuthProvider>
              <AudioProvider>
                <SpeechProvider>
                  <App />
                </SpeechProvider>
              </AudioProvider>
            </AuthProvider>
          </I18nProvider>
        </BrowserRouter>
      </GoogleOAuthProvider>
    </React.StrictMode>
  );

  reportWebVitals();
